var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"receipt"},[_c('div',{staticClass:"receipt_top"},[_c('img',{attrs:{"src":require("../../assets/receipt.png"),"alt":""}}),(_vm.mode===0)?_c('div',{staticClass:"back",on:{"click":_vm.toHome}},[_vm._v("返回首页")]):_vm._e(),(_vm.mode===1)?_c('div',{staticClass:"back",on:{"click":_vm.toHome}},[_vm._v("返回订餐")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }